<template>
  <v-text-field
    v-model="inputValue"
    :rules="GPARules"
    variant="outlined"
    density="compact"
  ></v-text-field>
</template>

<script>
import { objectTranslator } from "@/helper/translator";
import validator from "@/helper/validator";
export default {
  name: "gpaCard",
  props: {
    modelValue: String,
  },
  methods: {
    objectTranslator,
  },
  data: () => ({
    GPARules: [validator.gpa, validator.required],
  }),
  computed: {
    inputValue: {
      get() {
        return this.modelValue;
      },
      set(val) {
        this.$emit("update:modelValue", val);
      },
    },
  },
};
</script>
